import { IconButton } from '@scaleaq/scaleui';
import styled from 'styled-components';

import { colors, responsive } from '@/utils';

/** Circular overlay control shown while the camera widget is hovered. */
export const StyledCameraStreamControlButton = styled(IconButton)`
  border-radius: ${responsive.radius.rounded};
  /* Fixed and opaque: the button sits on video, so it must not follow the color mode or let it through.
     The dark scheme makes light-dark() tokens inside (the icon) resolve to their dark-mode value. */
  background-color: ${colors.palette.neutral.dark[500]};
  color-scheme: dark;

  /* Scale UI's hover and pressed fills are translucent; keep them opaque over video. */
  &&:not([data-loading]):not([data-disabled='true']):hover,
  &&:not([data-loading]):not([data-disabled='true']):active {
    background-color: ${colors.palette.neutral.dark[400]};
  }

  /* reset.css colors every svg with CSS, which beats the icon's own color attribute. */
  svg {
    color: ${colors.icon.action[100]};
  }
`;
